//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/Builder.js";
let d=[[[0,"Category",1,0],[0,"ClassID",1,0],[0,"DisabledToggle",1,0],[0,"InteractiveCheckingOnlyToggle",1,0],[0,"Name",1,0],[0,"SaveLogInPartToggle",1,0]],[[["folderPath"],"SetFolderPath",{},1,0],[["ruleFileName"],"SetRuleFileName",{},1,0],[["nText"],"GetDescription",{R_:{text:""}},0,0],[["text"],"SetDescription",{},1,0]],[]];
SPLM.Validate.RuleBaseSaveBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.RuleBaseSaveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;